import React from "react";

import { Box, Typography } from "@mui/material";

import CustomButton from "../../../helper-components/input/CustomButton";

export default function BackupCodesPanel(props) {
    const { codes = [], onContinue, continueTitle = "I have saved these codes" } = props;

    return (
        <Box sx={{ mt: 1, width: "100%" }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Save these backup codes somewhere safe. Each code signs you in once if you lose the authenticator. They will not be shown again.
            </Typography>
            <Box component="ul" sx={{ fontFamily: "monospace", pl: 2 }}>
                {codes.map((code) => (
                    <li key={code}>{code}</li>
                ))}
            </Box>
            <CustomButton {...props} title={continueTitle} onClick={onContinue} fullWidth />
        </Box>
    );
}
